import {useContext, useEffect, useRef, useState} from 'react';

import {useTranslation} from 'react-i18next';

import {SnackBarContext} from '../contexts/SnackBarContext/SnackBarContext';
import QuestionnaireSerializer from '../features/company/culture/surveys/serializers/QuestionnaireSerializer';
import {CompanySurveyQuestionnaire} from '../features/company/culture/surveys/types/SurveyQuestionnaireTypes';
import {Post} from '../lib/api/POST/Post';
import {PostRoutes} from '../lib/api/POST/PostRoutes';
import {GenerateQuestionnaireRequestBody} from '../lib/api/RequestBodies/features/company/Questionnaires/QuestionnaireRequestBodies';
import {ApiResponseError} from '../lib/api/v1/types';

import {useApiWrite} from './useApiWrite';

export const useGenerateNewQuestionnaire = (payload?: GenerateQuestionnaireRequestBody) => {
  const hasMounted = useRef(false);
  const {t} = useTranslation();
  const {dispatchMessage} = useContext(SnackBarContext);
  const [questionnaire, setQuestionnaire] = useState<CompanySurveyQuestionnaire>();

  const onSuccess = (data: {companySurveyQuestionnaire: CompanySurveyQuestionnaire}) => {
    setQuestionnaire(data.companySurveyQuestionnaire);
  };

  const onError = (apiError?: ApiResponseError) => {
    const details = apiError?.extra_details || apiError?.error_message;
    const message = details ? `${t('verification.errorMessage')} (${details})` : t('verification.errorMessage');
    dispatchMessage(message, 'error');
  };

  const {makeRequest, isLoading, error} = useApiWrite({
    method: 'post',
    path: PostRoutes[Post.GenerateNewQuestionnaire],
    camelCaseOverride: QuestionnaireSerializer.toGenerateResponse,
    onSuccess,
    onError,
  });

  useEffect(() => {
    if (isLoading || error || questionnaire || hasMounted.current) return;

    if (payload) {
      hasMounted.current = true;
      makeRequest(payload);
    }
  }, [payload, questionnaire, error, isLoading, makeRequest]);
  return {questionnaire, isLoading, error};
};
